module.exports = __webpack_public_path__ + "static/logo-0b3ce4f464567a4e47a3274647295deb.png";